// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2XPqv","dragIcon":"SortableItem_dragIcon__3qBhB","disabled":"SortableItem_disabled__1HrCb"};